/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, {useContext, useEffect, useState} from "react";
import Stockchart from "../stockchart_plotly";
import DisplayCards from "../metricCards";
import DynamicStockCharts from "../dynamicStockCharts_plotly";
import FundaTeaser from "../fundamentals/stockFundamentalTeaser";
import Plot from "react-plotly.js";
import {fetchMacros, fetchMarketIndices, fetchMarketSentiment, fetchPage} from "../../api";
import MarketBreadth from "./market_breadth";
import SectorPerformance from "./sector_performance";



const Rates = ({data}) => {
return (
    <div style={styles.container}>
        <div style={styles.chartBox}>
        <Plot
        data={[
          {
            x: data.inr_zc_curve.map(d => d.tenor),
            y: data.inr_zc_curve.map(d => d.yield),
            type: "scatter",
            mode: "lines",
            name: "Zero Curve",
            line: { color: "blue" },
          }
        ]}
        layout={{ title: "INR Zero Coupon Yield Curve ("+`${data.inr_zc_curve[1].curvedate}`+")", xaxis: { title: "Maturities (Years)" }, yaxis: { title: "Rates (%)" },
            // paper_bgcolor: "lightyellow", // Set the overall canvas color
          // plot_bgcolor: "lightcyan",  // Set the graph area background color
        }}
        style={{ width: '100%', height: '100%' }}  // Full width/height of container
      />
        </div>
        <div style={styles.chartBox}>
        <Plot
        data={[
          {
            x: data.inr_rate_1Y.map(d => d.period),
            y: data.inr_rate_1Y.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "1Y TBill",
            line: { color: "blue" },
          }
        ]}
        layout={{ title: "(1Y Rate)", yaxis: { title: "Rates (%)" } }}
      />
        {/*</div>*/}
        {/*<div style={styles.chartBox}>*/}
        <Plot
        data={[
          {
            x: data.inr_rate_10Y.map(d => d.period),
            y: data.inr_rate_10Y.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "10Y TBill",
            line: { color: "brown" },
          }
        ]}
        layout={{ title: "(GSec 10Y)",  yaxis: { title: "Rates (%)" } }}
      />
        </div>
        <div style={styles.chartBox}>
        <Plot
        data={[
          {
            x: data.inr_rate_90D.map(d => d.period),
            y: data.inr_rate_90D.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "90D TBill",
            line: { color: "brown" },
          }
        ]}
        layout={{ title: "(90D Treasury)",  yaxis: { title: "Rates (%)" } }}
      />
        {/*</div>*/}
        {/*<div style={styles.chartBox}>*/}
        <Plot
        data={[
          {
            x: data.inr_rate_180D.map(d => d.period),
            y: data.inr_rate_180D.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "180D TBill",
            line: { color: "brown" },
          }
        ]}
        layout={{ title: "(180D Treasury)",yaxis: { title: "Rates (%)" } }}
      />
        </div>
    </div>
);
}

const MacroIndicators = ({data}) => {
return (
    <div style={styles.container}>
        <div style={styles.chartBox}>
          <Plot
        data={[
          {
            x: data.gdp.map(d => d.period),
            y: data.gdp.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "GDP",
            line: { color: "green" },
          }
        ]}
        layout={{ title: "GDP at Mkt Prices",  yaxis: { title: "GDP (₹ Crore)" } }}
      />
        <Plot
        data={[
          {
            x: data.fx_reserves.map(d => d.period),
            y: data.fx_reserves.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "FX Reserves",
            line: { color: "brown" },
          }
        ]}
        layout={{ title: "FX Reserves",yaxis: { title: "(US $ Million)" } }}
      />
        </div>
        <div style={styles.chartBox}>
        <Plot
        data={[
          {
            x: data.cpi.map(d => d.period),
            y: data.cpi.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "CPI",
            line: { color: "blue" },
          }
        ]}
        layout={{ title: "CPI (Base 2012)", yaxis: { title: "Index" } }}
        // style={{ width: '100%', height: '100%' }}  // Full width/height of container
      />
        <Plot
        data={[
          {
            x: data.wpi.map(d => d.period),
            y: data.wpi.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "WPI",
            line: { color: "blue" },
          }
        ]}
        layout={{ title: "WPI (Base 2011)",  yaxis: { title: "Index" } }}
      />

        <Plot
        data={[
          {
            x: data.iip.map(d => d.period),
            y: data.iip.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "IIP",
            line: { color: "brown" },
          }
        ]}
        layout={{ title: "Index of Industrial Production",  yaxis: { title: "Index" } }}
      />
        </div>
    </div>
);
}

const Fiscals = ({data}) => {
return (
    <div style={styles.container}>
        <div style={styles.chartBox}>
          <Plot
        data={[
          {
            x: data.ex_debt.map(d => d.period),
            y: data.ex_debt.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "exDebt",
            line: { color: "green" },
          }
        ]}
        layout={{ title: "External Debt",  yaxis: { title: "(US $ Million)" } }}
      />
        <Plot
        data={[
          {
            x: data.fx_reserves.map(d => d.period),
            y: data.fx_reserves.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "FX Reserves",
            line: { color: "brown" },
          }
        ]}
        layout={{ title: "FX Reserves", yaxis: { title: "(US $ Million)" } }}
      />
        </div>
        <div style={styles.chartBox}>
        <Plot
        data={[
          {
            x: data.bop.map(d => d.period),
            y: data.bop.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "CPI",
            line: { color: "blue" },
          }
        ]}
        layout={{ title: "Balance of Payments", yaxis: { title: "(US $ Million)" } }}
        // style={{ width: '100%', height: '100%' }}  // Full width/height of container
      />
        <Plot
        data={[
          {
            x: data.sg_debt.map(d => d.period),
            y: data.sg_debt.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "WPI",
            line: { color: "blue" },
          }
        ]}
        layout={{ title: "State Govt Debt", yaxis: { title: "(₹ Crore)" } }}
      />
        </div>
    </div>
);
}

const Banking = ({data}) => {
return (
    <div style={styles.container}>
        <div style={styles.chartBox}>
          <Plot
        data={[
          {
            x: data.repo.map(d => d.period),
            y: data.repo.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "Repo Rate",
            line: { color: "green" },
          },
          {
            x: data.revrepo.map(d => d.period),
            y: data.revrepo.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "Reverse Repo Rate",
            line: { color: "blue" },
          }
        ]}
        layout={{ title: "RBI Policy Rates",
          yaxis: { title: "Rate( % )"  ,range: [-1,null] },
          legend: { orientation: "h" }, // Horizontal legend
          }}
      />
          <Plot
        data={[
          {
            x: data.crr.map(d => d.period),
            y: data.crr.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "CRR",
            line: { color: "green" },
          },
          {
            x: data.slr.map(d => d.period),
            y: data.slr.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "SLR",
            line: { color: "blue" },
          }
        ]}
        layout={{ title: "Liquidity Metrics",
          yaxis: { title: "Rate( % )" ,range: [-1,null] },
          legend: { orientation: "h" }, // Horizontal legend
          }}
      />
        </div>
        <div style={styles.chartBox}>
          <Plot
        data={[
          {
            x: data.bankcredit.map(d => d.period),
            y: data.bankcredit.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "Bank Credit",
            line: { color: "green" },
          },
          {
            x: data.bankdeposit.map(d => d.period),
            y: data.bankdeposit.map(d => d.value),
            type: "scatter",
            mode: "lines",
            name: "Bank Deposit",
            line: { color: "blue" },
          }
        ]}
        layout={{ title: "Credit / Deposit",
          yaxis: { title: "(₹ Crore)" },
          legend: { orientation: "h" }, // Horizontal legend
          }}
      />
        <Plot
      data={[
        {
          x: data.cdratio.map(d => d.period),
          y: data.cdratio.map(d => d.value),
          type: "scatter",
          mode: "lines",
          name: "Cash Deposit Ratio",
          line: { color: "green" },
        },
        {
          x: data.crratio.map(d => d.period),
          y: data.crratio.map(d => d.value),
          type: "scatter",
          mode: "lines",
          name: "Credit Deposit Ratio",
          line: { color: "blue" },
        }
      ]}
      layout={{ title: "Cash / Credit Ratio",
        yaxis: { title: "Rate ( % )" ,range: [-30,150] },
        legend: { orientation: "h" }, // Horizontal legend
        }}
    />
        </div>
    </div>
);
}


const MacroFI = () => {
  // const stockData = useContext(StockContext);
  // const [indices, setIndices] = useState([]);
  const subSections = ["Rates & Yield Curve", "Macro Indicators","Govt Fiscals","Banking & Credit", "Corporate Bond Spreads"];
  const [data, setData] = useState(null);
  const [activeSubTab, setActiveSubTab] = useState(subSections[0]);

  const [sentimentData, setSentimentData] = useState(null);
  const [vixData, setVixData] = useState([]);
  const [pcrData, setPcrData] = useState([]);
  const [optionFlowData, setOptionFlowData] = useState([]);

  useEffect(() => {
    fetchMacros()
      .then(data => {
        console.log("MACRO",data)
        setData(data);
      });
      }, []);

  if (!data) return <p>Loading data...</p>;

  console.log("SUMMARY DATA  RECVD" , sentimentData);
  // if (!stockData) return <p>Loading stock data...</p>;

  const renderContent = () => {

    switch (activeSubTab) {
        case "Rates & Yield Curve":
        return  data? (<div align={"center"}>
            <Rates data={data}/>
            </div>) : (
                <p>Loading Rates...</p>
              );
      case "Macro Indicators":
        return  data? (<div align={"center"} >
            <MacroIndicators data={data}/>
            </div>) : (
                <p>Loading data...</p>
              );
      case "Govt Fiscals":
        return  data? (<div align={"center"}>
            <Fiscals data={data}/>
            </div>) : (
                <p>Loading data...</p>
              );
      case "Banking & Credit":
        return  data? (<div align={"center"}>
            <Banking data={data}/>
            </div>) : (
                <p>Loading data...</p>
              );
      default:
        return <div>Select a tab to view content.</div>;
    }
  };

  return (
    <div className="section-container">
      {/* Vertical Sidebar */}
      <div className="sidebar">
        {subSections.map((tab) => (
          <button
            key={tab}
            className={`side-tab ${activeSubTab === tab ? "active" : ""}`}
            onClick={() => setActiveSubTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Display */}
      <div className="content">
        {/*<h2>{activeSubTab}</h2>*/}
        {/*<p>Displaying data for {activeSubTab}...</p>*/}
        {renderContent()}
      </div>
    </div>
  );
};

export default MacroFI;

// ✅ CSS-in-JS (Replacing Tailwind)
  // ✅ Styling
  const styles = {
    container: { padding: "16px", fontFamily: "Arial, sans-serif" },
    chartBox: { padding: "10px", border: "1px solid #ddd", borderRadius: "10px", backgroundColor: "white" ,     marginBottom: '20px'},
    treemapBox: { padding: "10px", border: "1px solid #ddd", borderRadius: "10px", backgroundColor: "white" }
  };